import React, { useState, useRef, useEffect } from 'react';
import "./TeamSubcription.css"
import sub1 from "../../images/sub1.png";
import sub2 from "../../images/sub2.png";
import tik from "../../images/sub-tick.png";
import s3 from "../../images/shape3.png";
import s4 from "../../images/shape4.png";
import s5 from "../../images/shape5.png";


import vl from "../../images/vl.png";
import pl from "../../images/pl.png";
import bl from "../../images/bl.png";
import yl from "../../images/yl.png";
import ylimg from "../../images/ylim.png";

import axios from 'axios';
import { END_URL, IMG_URL } from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import buttonloader from "../../images/buttonloader.gif";
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function TeamSubcription({ Subcription, onLoginChange, userdetail, subs }) {


    const [ButtonLoad, setButtonLoad] = useState(null);

    const [memberCount, setMemberCount] = useState("");

    const [memberError, setmemberError] = useState(false);

    const navigate = useNavigate();

    const images = [vl, pl, bl, yl];

    const LoginShow = () => {

        // window.scrollTo({ top: 0, behavior: 'smooth' });
        onLoginChange(true);
    };

    const token = localStorage.getItem('token');

    const handleNavigate = (slug) => {

        if (slug && slug.trim() !== "") {
            navigate(`/test/${slug}`);
        }
    };


    const handleSpecial = (slug) => {

            navigate(`/${slug}`);
    };

    
   const CustomPayment = async (sub_id, memberCount) => {

        if (!memberCount || memberCount < 1) {
            alert("Please enter a valid member count before submitting.");
            return;
        }

        try {
            
            setButtonLoad(sub_id);
            const payload = {
            sub_id: sub_id,
            member_count: memberCount,
            };

            const response = await fetch(`${END_URL}/submit-team-payment`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (data.payment) {

                alert("Custom plan payment submitted successfully!");

            } else {

            alert("Something went wrong. Please try again.");
            }
        } catch (error) {

            console.error("Error sending result:", error);
            alert("An error occurred while submitting. Please try again later.");

        } finally {
            setButtonLoad(null);
        }
    };



    const HandlePayment = (item) => {

        const InitializePayment = async () => {

            try {

                setButtonLoad(item.id);

                const response = await fetch(`${END_URL}/team-payment`, {

                    method: "POST",
                    headers: {

                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(item)

                });

                const data = await response.json();

                console.log(data.payment, 'fetch data');

                if (data.payment) {

                    setButtonLoad(null);
                    window.location.href = data.payment;

                } else {

                    setButtonLoad(null);

                    console.error("Invalid response:", data);
                    alert("An error occurred while processing the request.");
                }

            } catch (error) {

                console.error("Error sending result:", error);
            }
        };

        InitializePayment();

    };

     const [showDropdown, setShowDropdown] = useState(false);
       const dropdownRef = useRef(null);

 // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);



    return (

        <div className="subs-main">
            
            <div className="subs-sub-main">

                <div className="row1 subs-title">

                    <div className="subs-header" dangerouslySetInnerHTML={{ __html: Subcription?.sub_content }} />

                </div>

                <div className={subs ? 'row gy-4 subs-card-row subs-two' : 'row gy-4 subs-card-row'}>

                    <div className="col-12 col-sm-12 col-md-12" >


                        {Subcription && (

                            Subcription?.data?.map((item, index) => (

                                <div className="row content-row" key={index} style={{
                                    backgroundImage: `url(${images[index % images.length]})`, backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover'
                                }}>

                                    <div className={subs ? 'sub-for-large-none-col-md-3' : 'col-md-3'}>
                                        <div className="subs-right ">
                                            <img src={`${IMG_URL}/d0/${item.image}`} alt="" />
                                        </div>
                                    </div>

                                    <div className={subs ? "sub-for-col-md-9" : 'col-md-9'}>
                                        
                                        <div className="subs-left">
<div className="subs-box">
                                            <h5> {item.title}</h5>

                                            <div className="subs-amt">

                                                {item.price && (
                                                    <>
                                                        <span>${item.price}</span>

                                                        <span style={{ display: 'none' }} ></span>
                                                    </>
                                                )}

                                            </div>

                                            {item.image && ( 
                                                
                                                <div className={subs ? 'subs-right sub-for-large' : "sub-for-large-none"}>
                                                    <img src={`${IMG_URL}/d0/${item.image}`} alt="" />
                                                </div>
                                            )}

                                            </div>

                                            <div  className={subs ? 'sub-for-content' : "" } dangerouslySetInnerHTML={{ __html: item.description }} />


                                            {item.plan_type === "custom" && (
                                                <div className="custom-plan-section">
                                                    <div className="custom-input-box">
                                               
                                                        <div className="custom-input-row">
                                                              <input
                                                                    id="memberCount"
                                                                    type="number"
                                                                    placeholder="Enter member count"
                                                                    className="custom-input"
                                                                    min="1"
                                                                    required
                                                                    value={memberCount}
                                                                    onChange={(e) => setMemberCount(e.target.value)}
                                                                />
                                                            <button  onClick={() => CustomPayment(item.id, memberCount)} className="custom-submit-btn" type="button">

                                                                    Submit

                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {item.plan_type === "fixed" ? (
                                                
                                                <button onClick={() => HandlePayment(item)}>

                                                    {item.heading} <span> {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}</span> {ButtonLoad === item.id && <img index={index} src={buttonloader} alt="Loading" />}

                                                </button>

                                            ) :(

                                                 <button disabled >

                                                    {item.heading} <span> {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}</span> {ButtonLoad === item.id && <img index={index} src={buttonloader} alt="Loading" />}

                                                </button>
                                            )}


                                        </div>
                                    </div>



                                </div>

                            ))

                        )}

                    </div>


                </div>


            </div>

        </div>
    )
}

export default TeamSubcription